import { Box, BoxProps, Image } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";

const fragment = gql(/* GraphQL */ `
  fragment BrokerIcon on Broker {
    id
    name
    processedIcon {
      id
      width
      height
      fileUrl
    }
  }
`);

type Props = BoxProps & {
  broker: FragmentType<typeof fragment> | null | undefined;
};

export default function BrokerIcon({
  broker: brokerFragment,
  boxSize = "1em",
  ...rest
}: Props) {
  const broker = getFragmentData(fragment, brokerFragment);

  if (broker?.processedIcon?.fileUrl) {
    return (
      <Image
        src={broker.processedIcon.fileUrl}
        alt={broker.name}
        htmlWidth={broker.processedIcon.width}
        htmlHeight={broker.processedIcon.height}
        boxSize={boxSize}
        objectFit="contain"
        objectPosition="center center"
        position="relative"
        {...rest}
      />
    );
  }

  return (
    <Box
      as="span"
      display="block"
      boxSize={boxSize}
      position="relative"
      bg="gray.300"
      borderRadius="full"
      color="gray.600"
      fontWeight="bold"
      verticalAlign="middle"
      fontSize={boxSize}
      _before={{
        content: broker ? `"${broker.name.charAt(0).toUpperCase()}"` : '" "',
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "0.65em",
      }}
      {...rest}
    />
  );
}
